import type { Time } from '@morpho-org/morpho-ts'

import type { HistoryRange } from '@/lib/transforms/history/window'

export const DEFAULT_APY_HISTORY_TIMEFRAME: Time.PeriodLike = 'mo'

/** The history range of a chart timeframe option; "All time" (`null`) is `all`. */
export function toHistoryRange(timeFrame: Time.PeriodLike | null): HistoryRange {
  if (timeFrame === null) return 'all'
  if (timeFrame === 'w') return '1w'
  if (typeof timeFrame === 'object' && timeFrame.unit === 'mo' && timeFrame.duration === 3) {
    return '3m'
  }
  return '1m'
}
